import { render } from "./MemoApp.vue?vue&type=template&id=389cc59c&scoped=true"
import script from "./MemoApp.vue?vue&type=script&lang=js"
export * from "./MemoApp.vue?vue&type=script&lang=js"

import "./MemoApp.vue?vue&type=style&index=0&id=389cc59c&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-389cc59c"]])

export default __exports__